import { RoutePermissions } from '@nu-art/permissions-frontend/index';
import { Page_SmartDocs } from './Page_SmartDocs.js';
import { ModuleFE_Tag, ModuleFE_Variable } from '@app/hcs-frontend';
import { ModuleFE_SmartDoc } from '../../../_entity/smart-doc/ModuleFE_SmartDoc.js';
import { ModuleFE_FlowSheet } from '../../../_entity/flow-sheet/ModuleFE_FlowSheet.js';
import { ModuleFE_NoteTemplate } from '../../../_entity/note-template/ModuleFE_NoteTemplate.js';
import { ModuleFE_LogTemplate } from '../../../_entity/log-tempalte/ModuleFE_LogTemplate.js';
export const Route_Page_SmartDocs = {
    key: 'smart-doc-editor',
    path: 'smart-doc',
    enabled: RoutePermissions(ModuleFE_SmartDoc.permissions.ui.Release),
    Component: Page_SmartDocs,
    modulesToAwait: [
        ModuleFE_Tag,
        ModuleFE_Variable,
        ModuleFE_SmartDoc,
        ModuleFE_FlowSheet,
        ModuleFE_NoteTemplate,
        ModuleFE_LogTemplate,
    ],
};
//# sourceMappingURL=route.js.map